import { Component, EventEmitter, Output } from '@angular/core';
import { UpdateState } from 'src/app/shared/models/update-state';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { TaskMovementService } from 'src/app/shared/services/operations/task-movement.service';

import { StateUpdateService } from 'src/app/shared/services/state-update/state-update.service';
import { CommandType, TBTabName } from 'src/app/shared/entity/enums';
import { HttpStatusCode } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { ErrorMessage, ErrorType } from 'src/app/shared/entity/error.const';
import { TaskInfoService } from 'src/app/shared/services/task-info/task-info.service';
import { take } from 'rxjs';
@Component({
    selector: 'app-update-state',
    templateUrl: './update-state.component.html',
    styleUrl: './update-state.component.scss',
    standalone: false
})
export class UpdateStateComponent {
  @Output() handleUpdateStateSuccess = new EventEmitter<boolean>();

  showStatePopup : boolean = false;
  constructor(
    public taskMovementService: TaskMovementService,
    private readonly stateUpdateService: StateUpdateService,
    private readonly dataRepositoryService: DataRepositoryService,
    private readonly messageService: MessageService,
    private readonly taskInfoService: TaskInfoService
  ){
  }

  /**
   * 
   * @param data 
   */
  handleStateUpdate(data: { state: string; reason: string;}) {
    const payload:UpdateState[]  = this.getPayload(data);
    this.stateUpdateService.updateState(payload).pipe(take(1)).subscribe({
      next:() => {
        
        this.showStatePopup = false;
        this.messageService.add({ severity: ErrorType.SUCCESS, closable: false, summary: '', detail: ErrorMessage.STATEUPDATEMESSAGE });
        this.handleUpdateStateSuccess.emit(true);
      },
      error: (error) => {
        console.log(error);
        if (error.status === HttpStatusCode.Forbidden) {
          this.messageService.add({ severity: ErrorType.ERROR, closable: false, summary: '', detail: ErrorMessage.RESTRICTIONMESSAGE });
        } else {
          this.messageService.add({ severity: ErrorType.ERROR, closable: false, summary: '', detail: ErrorMessage.STATEUPDATEERRORMESSAGE });
        }
      }       
    });
  }

  /**
   * 
   * @param data 
   * @returns 
   */
  getPayload(data: { state: string; reason: string;}) {
    let tasks:any = [];
    [...this.dataRepositoryService.movingTasksMap.values()].forEach(item => {
      tasks.push(item?.task_id);
    });
    const payload:UpdateState[] = [{
      id: crypto.randomUUID(),
      command_type: CommandType.StateChange,
      state: data?.state,
      timestamp: new Date(),
      task_id: tasks,
      HCP: {
          reason_code: data?.reason
      }
    }]
    return payload;
  }

}
